import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { type KeyboardEvent, useEffect, useRef, useState } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

type Props = {
  title?: string
  onSubmit: (value: string) => void
}

export const FolderInput: React.FC<Props> = ({ title, onSubmit }) => {
  const [focus, setFocus] = useState(false)
  const [value, setValue] = useState(title || '')
  const ref = useRef<HTMLInputElement | null>(null)

  const disabled = !value.trim()

  useEffect(() => {
    ref.current?.focus()
  }, [])

  const handleSubmit = () => {
    onSubmit(value)
  }

  const handleKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Escape') {
      setFocus(false)
      handleSubmit()
    }

    if (event.key === 'Enter') {
      handleSubmit()
      setFocus(false)
    }
  }

  return (
    <div className={clsJoin(css.input_wrap, focus && css.focus)}>
      <input
        ref={ref}
        value={value}
        className={css.input}
        onKeyUp={handleKeyUp}
        onFocus={() => setFocus(true)}
        onChange={(event) => setValue(event.target.value)}
        onBlur={handleSubmit}
      />

      <Button
        size="xxsmall"
        label="Ok"
        disabled={disabled}
        onClick={handleSubmit}
      />
    </div>
  )
}
